/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { concat, get } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import sub_ from 'ember-math-helpers/helpers/sub';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';
import type AdverseEventModel from 'parog-web/models/adverse-event';

interface DiscreteRangeSignature {
  adverseEvent: AdverseEventModel;
  form: ForcProviderBaseSignature['Blocks']['default'][0];
}

const DiscreteRange: TOC<DiscreteRangeSignature> = <template>
  <@form.Range
    @label={{t
      (concat 'adverse-event.labels.' @adverseEvent.id)
      default='adverse-event.labels.other'
    }}
    @payloadKey='evaScore'
    {{! @glint-expect-error }}
    @min={{0}}
    {{! @glint-expect-error }}
    @max={{get @adverseEvent.values (sub_ @adverseEvent.values.length 1)}}
    {{! @glint-expect-error }}
    @step={{1}}
    class='mb-12 flex flex-col'
  >
    <:values>
      <div class='mt-[8px] flex shrink grow basis-0 justify-between'>
        {{#each @adverseEvent.values as |value|}}
          <label
            data-test-range-value={{value}}
            class='basis-full text-center first:basis-[50%] last:basis-[50%]'
          >{{t
              (concat
                'adverse-event.discrete-values.' @adverseEvent.id '.' value
              )
            }}</label>
        {{/each}}
      </div>
    </:values>
  </@form.Range>
</template>;

export default DiscreteRange;
